import { render } from "./KPIs.vue?vue&type=template&id=79e79d7b&scoped=true"
import script from "./KPIs.vue?vue&type=script&lang=js"
export * from "./KPIs.vue?vue&type=script&lang=js"

import "./KPIs.vue?vue&type=style&index=0&id=79e79d7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e79d7b"]])

export default __exports__